// eslint-disable-next-line no-unused-vars
import React from 'react';
import PropTypes from 'prop-types';
import { FocusTrap as BaseFocusTrap } from 'focus-trap-react';

export const FocusTrap = ({ children, ...props }) => {
    return (
        <BaseFocusTrap
            disableEnforceFocus
            focusTrapOptions={{
                allowOutsideClick: true,
                tabbableOptions: {
                    displayCheck: 'legacy-full'
                }
            }}
            {...props}
        >
            {children}
        </BaseFocusTrap>
    );
};

FocusTrap.propTypes = {
    children: PropTypes.node
};
